import React, { useContext, useState } from 'react';
import {
  CircularProgress,
  Container,
  Grid,
  Switch,
  Typography
} from '@mui/material';
import TopologyColumn from './topologyColumn';
import {
  getAmount,
  getHighestConnectionValue,
  JSONRecordData
} from '../Log/graph.util';
import { ProductIdContext } from '../../../contexts/ProductIdContextProvider';
import { FormattedMessage } from 'react-intl';

interface TopologySodistoreHomeProps {
  values: JSONRecordData;
  connected: boolean;
  loading: boolean;
  batteryClusterNumber:number;
}

function TopologySodistoreHome(props: TopologySodistoreHomeProps) {
  if (props.values === null && props.connected == true) {
    return null;
  }
  const highestConnectionValue =
    props.values != null ? getHighestConnectionValue(props.values) : 0;

  const { product, setProduct } = useContext(ProductIdContext);

  const [showValues, setShowValues] = useState(false);

  const handleSwitch = () => () => {
    setShowValues(!showValues);
  };

  const isMobile = window.innerWidth <= 1490;

  const inv = props.values?.InverterRecord;
  const hasDevices = !!inv?.Devices;

  const totalBatteryPower: number = hasDevices
    ? (inv?.TotalBatteryPower ?? 0)
    : Number(
        Array.from({ length: props.batteryClusterNumber }).reduce(
          (sum: number, _, index) => sum + (Number(inv?.[`Battery${index + 1}Power`]) || 0),
          0
        )
      );

  const pvPower: number = hasDevices
    ? (inv?.TotalPhotovoltaicPower ?? 0)
    : (inv?.PvPower ??
      ['PvPower1', 'PvPower2', 'PvPower3', 'PvPower4']
        .map((key) => inv?.[key] ?? 0)
        .reduce((sum, val) => sum + val, 0));

  const totalLoadPower: number = hasDevices
    ? (inv?.TotalLoadPower ?? 0)
    : (inv?.ConsumptionPower ?? 0);

  const totalGridPower: number =
    inv?.TotalGridPower ?? inv?.GridPower ?? 0;

  return (
    <Container maxWidth="xl" style={{ backgroundColor: 'white' }}>
      <Grid container>
        {!props.connected && !props.loading && (
          <Container
            maxWidth="xl"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '70vh'
            }}
          >
            <CircularProgress size={60} style={{ color: '#ffc04d' }} />
            <Typography
              variant="body2"
              style={{ color: 'black', fontWeight: 'bold' }}
              mt={2}
            >
              <FormattedMessage id="unableToCommunicate" defaultMessage="Unable to communicate with the installation" />
            </Typography>
            <Typography variant="body2" style={{ color: 'black' }}>
              <FormattedMessage id="pleaseWaitOrRefresh" defaultMessage="Please wait or refresh the page" />
            </Typography>
          </Container>
        )}

        {props.connected && (
          <>
            <Grid
              item
              xs={12}
              md={12}
              style={{
                marginTop: '10px',
                height: '20px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'right',
                justifyContent: 'right'
              }}
            >
              {/*<div>*/}
              {/*  <Typography sx={{ marginTop: '5px', marginRight: '20px' }}>*/}
              {/*    Display Values*/}
              {/*  </Typography>*/}
              {/*  <Switch*/}
              {/*    edge="start"*/}
              {/*    color="secondary"*/}
              {/*    onChange={handleSwitch()}*/}
              {/*    sx={{*/}
              {/*      '& .MuiSwitch-thumb': {*/}
              {/*        backgroundColor: 'orange'*/}
              {/*      },*/}
              {/*      marginLeft: '20px'*/}
              {/*    }}*/}
              {/*  />*/}
              {/*</div>*/}
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              style={{
                height: isMobile ? '550px' : '600px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <TopologyColumn
                centerBox={{
                  title: 'Grid',
                  data: props.values?.InverterRecord
                    ? [
                      {
                        value: totalGridPower,
                        unit: 'W'
                      }
                    ]
                    : undefined,
                  connected:
                    true
                }}
                centerConnection={{
                  orientation: 'horizontal',
                  data: props.values?.InverterRecord
                    ? {
                      value: totalGridPower,
                      unit: 'W'
                    }
                    : undefined,
                  amount: props.values?.InverterRecord
                    ? getAmount(
                      highestConnectionValue,
                      totalGridPower
                    )
                    : 0,
                  showValues: showValues
                }}
                isLast={false}
                isFirst={true}
              />
              {/*-------------------------------------------------------------------------------------------------------------------------------------------------------------*/}
              <TopologyColumn
                topBox={{
                  title: 'PV',
                  data: props.values?.InverterRecord
                    ? [
                      {
                        value: pvPower,
                        unit: 'W'
                      }
                    ]
                    : undefined,
                  connected: true
                }}
                topConnection={{
                  orientation: 'vertical',
                  position: 'top',
                  data: props.values?.InverterRecord
                    ? {
                      value: pvPower,
                      unit: 'W'
                    }
                    : undefined,
                  amount: props.values?.InverterRecord ? getAmount(highestConnectionValue, pvPower) : 0,
                  showValues: showValues
                }}
              centerBox={{
                  title: 'Inverter',
                  data: props.values?.InverterRecord
                    ? [
                      {
                        value: 0,
                        unit: 'W'
                      }
                    ]
                    : undefined,
                  connected: true
                }}
                centerConnection={{
                  orientation: 'horizontal',
                  data: props.values?.InverterRecord
                    ? {
                      value: totalBatteryPower,
                      unit: 'W'
                    }
                    : undefined,
                  amount: props.values?.InverterRecord
                    ? getAmount(highestConnectionValue, totalBatteryPower)
                    : 0,
                  showValues: showValues
                }}
                bottomBox={{
                  title: 'Loads',
                  data: props.values?.InverterRecord
                    ? [
                      {
                        value: totalLoadPower,
                        unit: 'W'
                      }
                    ]
                    : undefined,
                  connected:true
                }}
                bottomConnection={{
                  orientation: 'vertical',
                  position: 'bottom',
                  data: props.values?.InverterRecord
                    ? {
                      value: totalLoadPower,
                      unit: 'W'
                    }
                    : undefined,
                  amount: props.values?.InverterRecord
                    ? getAmount(
                      highestConnectionValue,
                      totalLoadPower
                    )
                    : 0,
                  showValues: showValues
                }}
                isLast={false}
                isFirst={false}
              />
              {/*-------------------------------------------------------------------------------------------------------------------------------------------------------------*/}
              {Array.from({ length: props.batteryClusterNumber }).map((_, index) => {
                let soc: number;
                let power: number;

                if (hasDevices) {
                  // Sinexcel: map across devices — 0→D1/B1, 1→D1/B2, 2→D2/B1, 3→D2/B2
                  const deviceId = String(Math.floor(index / 2) + 1);
                  const batteryIndex = (index % 2) + 1;
                  const device = inv?.Devices?.[deviceId];
                  soc = device?.[`Battery${batteryIndex}Soc`] ?? device?.[`Battery${batteryIndex}SocSecondvalue`] ?? 0;
                  power = device?.[`Battery${batteryIndex}Power`] ?? 0;
                } else {
                  // Growatt: flat Battery1, Battery2, ...
                  const i = index + 1;
                  soc = Number(inv?.[`Battery${i}Soc`]) || 0;
                  power = Number(inv?.[`Battery${i}Power`]) || 0;
                }

                return (
                  <TopologyColumn
                    key={index + 1}
                    centerBox={{
                      title: `Battery C${index + 1}`,
                      data: inv
                        ? [
                          { value: soc, unit: '%' },
                          { value: power, unit: 'W' }
                        ]
                        : undefined,
                      connected: true
                    }}
                    isFirst={false}
                    isLast={true}
                  />
                );
              })}
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
}

export default TopologySodistoreHome;
